import * as React from 'react'
import { useDispatch } from 'redux-react-hook'
import { setPage } from '../../../actions/header.action'
// import { setDayReportLogs } from '../../../actions/report.action'
// import { Header } from '../..//molecules/header'
import styled from 'styled-components'
import { Size } from '../../../constants/app.constant'
import Contents from './contents'
import * as HeaderConst from '../../../constants/header.constant'
// import useGetState from '../../../hooks/use-get-state'
// import useFetchApi from '../../../hooks/use-fetch-api'
// import { axiosObj } from '../../../services/api.service'
// import axios from 'axios'

const { useEffect } = React
const Report = ({ match }) => {
  const dispatch = useDispatch()
  /*
  const {
    state: { auth },
  } = useGetState()
  */
  useEffect(
    () => {
      document.title = '運動レポート画面'
      dispatch(setPage(HeaderConst.HEADER_REPORT))
    },
    [dispatch]
  )
  // let isLoading = false;
  /*
  useEffect(
    () => {
      const password = 'abcdefghi1';
      const post = async (password: string) => {
        try{
          const API_BASE_URL = String(process.env.REACT_APP_MOFF_API_URL)
          const axiosObj = (options?: any) => {
            return axios.create({
                baseURL: API_BASE_URL,
              })
            }
          const response  = await axiosObj().post(`shared/${match.params.key}/get`, { password: password })
          if (response && response.data && response.data.patientDayTrainingLogs) {
            dispatch(setDayReportLogs(response.data.patientDayTrainingLogs))
          }
        } catch (e) {
          throw e
        }
      } 
      post(password).then(() => {
        isLoading = true;
      });
    },
    [dispatch]
  )
  */
  return (
    // !isLoading && (
    <Wrapper>
      {/* <Header /> */}
      <Contents param={match.params.key} />
    </Wrapper>
    // )
  )
}
export default Report
const Wrapper = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  background: white;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/pages/share/report.tsx